import { gql } from '@apollo/client';
import { IOrder } from '@global/types/types';

// Requests
export interface REQUEST_CART_TYPE {
  wGetCheckoutCart: {
    result: {
      status: string;
      order: IOrder;
    };
  };
}

export const REQUEST_CART = gql`
  query wGetCheckoutCart($uid: UUID!, $ecomToken: String) {
    wGetCheckoutCart(uid: $uid, ecomToken: $ecomToken)
  }
`;
